import React, { memo, useState } from 'react';

import { QuickFilter } from '../../components';
import { ContactTable, ContactWizard } from '../../views/Users/index.jsx';

export const AssignLookbook = memo(function AssignLookbook({
  onAssignClient,
}) {
  const [isCreatingClient, setIsCreatingClient] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="assign-lookbook">
      <div className="cover-subtitle">Assign Lookbook:</div>

      {isCreatingClient ? (
        <ContactWizard
          className="find-product-create-client"
          submitLabel="Select"
          afterSubmit={onAssignClient}
          onCancel={() => setIsCreatingClient(false)}
        />
      ) : (
        <div className="find-product-contacts lb-assign-clients">
          <QuickFilter
            className="contacts lb-assign-clients__search"
            placeholder="Quick search for clients"
            onUpdate={setSearchQuery}
          />

          <div className="contacts-table-card card">
            <div className="body">
              <div className="lb-assign-clients__actions">
                <button
                  type="button"
                  className="lb-create-client-btn"
                  onClick={() => setIsCreatingClient(true)}
                >
                  <span className="lb-create-client-btn__plus" aria-hidden="true">+</span>
                  Create a new client
                </button>
              </div>

              <ContactTable
                onSelectClick={onAssignClient}
                searchQuery={searchQuery}
                addLoggedUserFirst
                minSearchLength={3}
                pickerLayout="horizontal"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
